import { render, staticRenderFns } from "./register-products.vue?vue&type=template&id=22bacf25&scoped=true&"
import script from "./register-products.vue?vue&type=script&lang=tsx&"
export * from "./register-products.vue?vue&type=script&lang=tsx&"
import style0 from "./register-products.vue?vue&type=style&index=0&id=22bacf25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bacf25",
  null
  
)

export default component.exports